import type { HTMLProps, KeyboardEventHandler, MouseEventHandler, ReactNode } from "react";

import { Icon } from "./icon";
import type { IconName, IconSize } from "./types-icon";

/** Classe do PrimeIcons (`"pi pi-lock"`): só para o ícone que a biblioteca do Figma não tem. */
export type PrimeIconClass = `pi pi-${string}`;

export const isPrimeIconClass = (icon: IconName | PrimeIconClass): icon is PrimeIconClass =>
  icon.startsWith("pi ");

/** Opções que o Prime entrega a um ícone em formato de função (`dropdownIcon`, `removeIcon`, `icon`...). */
interface PrimeIconOptions {
  iconProps?: Pick<
    HTMLProps<unknown>,
    "className" | "onClick" | "onKeyDown" | "tabIndex" | "aria-label"
  > & { "data-testid"?: string };
}

/**
 * Ícone do DS no lugar do ícone padrão do Prime: devolve a função que as props de ícone do Prime aceitam
 * (`dropdownIcon`, `clearIcon`, `removeIcon`, `checkboxIcon`, `prevIcon`, `icon`...). Recebe as props do Prime
 * (`className`, `onClick`, `tabIndex`...) para manter as classes `p-*` que o tema usa e os handlers do componente.
 */
export function primeIcon(name: IconName, size: IconSize = 14) {
  const render = (options: PrimeIconOptions): ReactNode => {
    const { iconProps = {} } = options;
    const {
      className,
      onClick,
      onKeyDown,
      tabIndex,
      "aria-label": ariaLabel,
      "data-testid": testId,
    } = iconProps;

    return (
      <Icon
        name={name}
        size={size}
        className={className}
        tabIndex={tabIndex}
        data-testid={testId}
        onClick={
          onClick as MouseEventHandler<unknown> as MouseEventHandler<SVGSVGElement> | undefined
        }
        onKeyDown={
          onKeyDown as KeyboardEventHandler<unknown> as
            KeyboardEventHandler<SVGSVGElement> | undefined
        }
        {...(ariaLabel ? { title: ariaLabel } : {})}
      />
    );
  };
  return render;
}
